// services/estruturaCategorias.js

const estruturaCategorias = {
  'oscar-indicados': {
    melhorfilme: 10,
    melhordirecao: 5,
    melhorator: 5,
    melhoratriz: 5,
    melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5,
    melhorescalacaodeelenco: 5,
    melhorroteirooriginal: 5,
    melhorroteiroadaptado: 5,
    melhorfilmeinternacional: 5,
    melhoranimacao: 5,
    melhordocumentario: 5,
    melhoredicao: 5,
    melhorfotografia: 5,
    melhorfigurino: 5,
    melhordirecaodearte: 5,
    melhormaquiagem: 5,
    melhorefeitosvisuais: 5,
    melhortrilhasonora: 5,
    melhorcancaooriginal: 5,
    melhorsom: 5,
    melhorcurtametragem: 5,
    melhoranimacaoemcurtametragem: 5,
    melhordocumentarioemcurtametragem: 5,
    melhorduble: 5
  },
  'oscar-vencedores': {
    melhorfilme: 10,
    melhordirecao: 5,
    melhorator: 5,
    melhoratriz: 5,
    melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5,
    melhorescalacaodeelenco: 5,
    melhorroteirooriginal: 5,
    melhorroteiroadaptado: 5,
    melhorfilmeinternacional: 5,
    melhoranimacao: 5,
    melhordocumentario: 5,
    melhoredicao: 5,
    melhorfotografia: 5,
    melhorfigurino: 5,
    melhordirecaodearte: 5,
    melhormaquiagem: 5,
    melhorefeitosvisuais: 5,
    melhortrilhasonora: 5,
    melhorcancaooriginal: 5,
    melhorsom: 5,
    melhorcurtametragem: 5,
    melhoranimacaoemcurtametragem: 5,
    melhordocumentarioemcurtametragem: 5,
    melhorduble: 5
  },
  'globodeouro-indicados': {
    melhorfilmeemdrama: 6,
    melhorfilmeemcomedia: 6,
    melhorfilmeblockbuster: 8,
    melhordirecao: 6,
    melhoratoremdrama: 6,
    melhoratrizemdrama: 6,
    melhoratoremcomediaoumusical: 6,
    melhoratrizemcomediaoumusical: 6,
    melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6,
    melhorroteiro: 6,
    melhorcancaooriginal: 6,
    melhortrilhasonora: 6,
    melhoranimacao: 6,
    melhorfilmeemlinguanaoinglesa: 6
  },
  'globodeouro-vencedores': {
    melhorfilmeemdrama: 6,
    melhorfilmeemcomedia: 6,
    melhorfilmeblockbuster: 8,
    melhordirecao: 6,
    melhoratoremdrama: 6,
    melhoratrizemdrama: 6,
    melhoratoremcomediaoumusical: 6,
    melhoratrizemcomediaoumusical: 6,
    melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6,
    melhorroteiro: 6,
    melhorcancaooriginal: 6,
    melhortrilhasonora: 6,
    melhoranimacao: 6,
    melhorfilmeemlinguanaoinglesa: 6
  },
  'sagawards-indicados': {
    melhorelenco: 5,
    melhorator: 5,
    melhoratriz: 5,
    melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5,
    melhorequipededuble: 5
  },
  'sagawards-vencedores': {
    melhorelenco: 5,
    melhorator: 5,
    melhoratriz: 5,
    melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5,
    melhorequipededuble: 5
  },
  'criticschoice-indicados': {
    melhorfilme: 10,
    melhordirecao: 10,
    melhorator: 6,
    melhoratriz: 6,
    melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6,
    melhorjovematoratriz: 6,
    melhorroteirooriginal: 6,
    melhorroteiroadaptado: 6,
    melhorfotografia: 6,
    melhoredicao: 6,
    melhordirecaodearte: 6,
    melhorfigurino: 6,
    melhormaquiagem: 6,
    melhorefeitosvisuais: 6,
    melhorcomedia: 6,
    melhorfilmeinternacional: 6,
    melhoranimacao: 6,
    melhorcancao: 6,
    melhortrilhasonora: 6,
    melhorduble: 6,
    melhorescalacaodeelenco: 6,
    melhorsom: 6
  },
  'criticschoice-vencedores': {
    melhorfilme: 10,
    melhordirecao: 6,
    melhorator: 6,
    melhoratriz: 6,
    melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6,
    melhorjovematoratriz: 6,
    melhorroteirooriginal: 6,
    melhorroteiroadaptado: 6,
    melhorfotografia: 6,
    melhoredicao: 6,
    melhordirecaodearte: 6,
    melhorfigurino: 6,
    melhormaquiagem: 6,
    melhorefeitosvisuais: 6,
    melhorcomedia: 6,
    melhorfilmeinternacional: 6,
    melhoranimacao: 6,
    melhorcancao: 6,
    melhortrilhasonora: 6,
    melhorduble: 6,
    melhorescalacaodeelenco: 6,
    melhorsom: 6
  },
  'dga-indicados': {
    melhordirecao: 5
  },
  'dga-vencedores': {
    melhordirecao: 5
  },
  'pga-indicados': {
    melhorfilme: 10,
    melhoranimacao: 5,
    melhordocumentario: 7
  },
  'pga-vencedores': {
    melhorfilme: 10,
    melhoranimacao: 5,
    melhordocumentario: 7
  },
  'bafta-indicados': {
    melhorfilme: 5,
    melhordirecao: 6,
    melhorfilmeinternacional: 5,
    melhorfilmebritanico: 10,
    melhorfilmefamiliar: 4,
    melhordocumentario: 5,
    melhoranimacao: 4,
    melhorator: 6,
    melhoratriz: 6,
    melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6,
    melhoratoratrizemascensao: 5,
    melhorescalacao: 5,
    melhorestreiadeumdiretorescritorouprodutorbritanico: 5,
    melhorroteirooriginal: 5,
    melhorroteiroadaptado: 5,
    melhorfotografia: 5,
    melhorfigurino: 5,
    melhorsom: 5,
    melhoredicao: 5,
    melhorefeitosvisuais: 5,
    melhordirecaodearte: 5,
    melhormaquiagem: 5,
    melhortrilhasonora: 5,
    melhorcurtabritanico: 5,
    melhorcurtadeanimacaobritanico: 3
  },
  'bafta-vencedores': {
    melhorfilme: 5,
    melhordirecao: 6,
    melhorfilmeinternacional: 5,
    melhorfilmebritanico: 10,
    melhorfilmefamiliar: 4,
    melhordocumentario: 5,
    melhoranimacao: 3,
    melhorator: 6,
    melhoratriz: 6,
    melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6,
    melhoratoratrizemascensao: 5,
    melhorescalacao: 5,
    melhorestreiadeumdiretorescritorouprodutorbritanico: 5,
    melhorroteirooriginal: 5,
    melhorroteiroadaptado: 5,
    melhorfotografia: 5,
    melhorfigurino: 5,
    melhorsom: 5,
    melhoredicao: 5,
    melhorefeitosvisuais: 5,
    melhordirecaodearte: 5,
    melhormaquiagem: 5,
    melhortrilhasonora: 5,
    melhorcurtabritanico: 5,
    melhorcurtadeanimacaobritanico: 3
  }
};

export const categoriasPorModo = {
  "oscar-indicados": [
    "melhorfilme", "melhordirecao", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante",
    "melhorescalacaodeelenco", "melhorroteirooriginal", "melhorroteiroadaptado", "melhorfilmeinternacional",
    "melhoranimacao", "melhordocumentario", "melhoredicao", "melhorfotografia", "melhorfigurino",
    "melhordirecaodearte", "melhormaquiagem", "melhorefeitosvisuais", "melhortrilhasonora", "melhorcancaooriginal",
    "melhorsom", "melhorcurtametragem", "melhoranimacaoemcurtametragem", "melhordocumentarioemcurtametragem", "melhorduble"
  ],
  "oscar-vencedores": [ "melhorfilme", "melhordirecao", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante",
    "melhorescalacaodeelenco", "melhorroteirooriginal", "melhorroteiroadaptado", "melhorfilmeinternacional",
    "melhoranimacao", "melhordocumentario", "melhoredicao", "melhorfotografia", "melhorfigurino",
    "melhordirecaodearte", "melhormaquiagem", "melhorefeitosvisuais", "melhortrilhasonora", "melhorcancaooriginal",
    "melhorsom", "melhorcurtametragem", "melhoranimacaoemcurtametragem", "melhordocumentarioemcurtametragem", "melhorduble" ],
  "globodeouro-indicados": [ "melhorfilmeemdrama", "melhorfilmeemcomedia", "melhorfilmeblockbuster", "melhordirecao", "melhoratoremdrama", "melhoratrizemdrama", "melhoratoremcomediaoumusical", "melhoratrizemcomediaoumusical", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhorroteiro", "melhorcancaooriginal", "melhortrilhasonora", "melhoranimacao", "melhorfilmeemlinguanaoinglesa" ],
  "globodeouro-vencedores": [ "melhorfilmeemdrama", "melhorfilmeemcomedia", "melhorfilmeblockbuster", "melhordirecao", "melhoratoremdrama", "melhoratrizemdrama", "melhoratoremcomediaoumusical", "melhoratrizemcomediaoumusical", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhorroteiro", "melhorcancaooriginal", "melhortrilhasonora", "melhoranimacao", "melhorfilmeemlinguanaoinglesa" ],
  "sagawards-indicados": [ "melhorelenco", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhorequipededuble" ],
  "sagawards-vencedores": [ "melhorelenco", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhorequipededuble" ],
  "criticschoice-indicados": [ "melhorfilme", "melhordirecao", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhorjovematoratriz", "melhorroteirooriginal", "melhorroteiroadaptado", "melhorfotografia", "melhoredicao", "melhordirecaodearte", "melhorfigurino", "melhormaquiagem", "melhorefeitosvisuais", "melhorcomedia", "melhorfilmeinternacional", "melhoranimacao", "melhorcancao", "melhortrilhasonora","melhorduble", "melhorescalacaodeelenco","melhorsom"],
  "criticschoice-vencedores": [ "melhorfilme", "melhordirecao", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhorjovematoratriz", "melhorroteirooriginal", "melhorroteiroadaptado", "melhorfotografia", "melhoredicao", "melhordirecaodearte", "melhorfigurino", "melhormaquiagem", "melhorefeitosvisuais", "melhorcomedia", "melhorfilmeinternacional", "melhoranimacao", "melhorcancao", "melhortrilhasonora","melhorduble", "melhorescalacaodeelenco","melhorsom"],
  "dga-indicados": [ "melhordirecao" ],
  "dga-vencedores": [ "melhordirecao" ],
  "pga-indicados": [ "melhorfilme", "melhoranimacao", "melhordocumentario" ],
  "pga-vencedores": [ "melhorfilme", "melhoranimacao", "melhordocumentario" ],
  "bafta-indicados": [ "melhorfilme", "melhordirecao", "melhorfilmeinternacional", "melhorfilmebritanico", "melhorfilmefamiliar", "melhordocumentario", "melhoranimacao", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhoratoratrizemascensao", "melhorescalacao", "melhorestreiadeumdiretorescritorouprodutorbritanico", "melhorroteirooriginal", "melhorroteiroadaptado", "melhorfotografia", "melhorfigurino", "melhorsom", "melhoredicao", "melhorefeitosvisuais", "melhordirecaodearte", "melhormaquiagem", "melhortrilhasonora", "melhorcurtabritanico", "melhorcurtadeanimacaobritanico" ],
  "bafta-vencedores": [ "melhorfilme", "melhordirecao", "melhorfilmeinternacional", "melhorfilmebritanico", "melhorfilmefamiliar", "melhordocumentario", "melhoranimacao", "melhorator", "melhoratriz", "melhoratorcoadjuvante", "melhoratrizcoadjuvante", "melhoratoratrizemascensao", "melhorescalacao", "melhorestreiadeumdiretorescritorouprodutorbritanico", "melhorroteirooriginal", "melhorroteiroadaptado", "melhorfotografia", "melhorfigurino", "melhorsom", "melhoredicao", "melhorefeitosvisuais", "melhordirecaodearte", "melhormaquiagem", "melhortrilhasonora", "melhorcurtabritanico", "melhorcurtadeanimacaobritanico" ]
};






// Função segura para obter o total de posições por modo/categoria
export function getTotalPosicoes(modo, categoria) {
  if (!estruturaCategorias[modo]) {
    console.warn(`❌ Modo inválido: "${modo}"`);
    return null;
  }

  const total = estruturaCategorias[modo][categoria];

  if (!total) {
    console.warn(`❌ Categoria inválida: "${categoria}" no modo "${modo}"`);
    return null;
  }

  return total;
}

export default estruturaCategorias;